<div mat-dialog-title class="title_container">
  <img src="assets/alarm_primary.svg" class="alarm-icon">
  <span class="title_text">Session Timeout Warning</span>
</div>

<div mat-dialog-content class="content_container">
  <p>
    Your session will automatically expire in
    <span class="remaining_time_wrapper">{{remainingTimeText}}</span> 
  </p>
  <p>
    Any unsaved work will be lost when your session ends. Select “Continue” to
    extend your session and stay logged in.
  </p>
</div>

<div mat-dialog-actions class="cta_container">
  <button mat-button (click)="onEndSession()" class="button-secondary-red">
    END SESSION
  </button>
  <button
    mat-button
    (click)="onContinue()"
    class="button-primary"
    cdkFocusInitial
  >
    CONTINUE
  </button>
</div>
